// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/components';
import { useNavigateKeepSearch } from '@hooks/useNavigateKeepSearch';
import { Tooltip } from 'antd';
import { Grip } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './PageLayout.less';

const AppLauncher = () => {
  const { t } = useTranslation();
  const navigateKeepSearch = useNavigateKeepSearch();
  const label = t('common.header.imp-hub');

  return (
    <Tooltip title={label} trigger={['hover', 'focus']}>
      <Button
        type="text"
        className="header-icon-button"
        aria-label={label}
        icon={<Grip size={24} aria-hidden />}
        onClick={() => navigateKeepSearch('/')}
      />
    </Tooltip>
  );
};

export default AppLauncher;
